(function($) {

  var min = 0;
  jQuery('.home-feature .row > .col-md-6.col-sm-6.col-xs-12').each(function(){
    var hei = jQuery(this).outerHeight();
    if(min < hei){ min = hei } 
      jQuery('.home-feature .row > .col-md-6.col-sm-6.col-xs-12 img').height(min)
  })

  jQuery( ".header-links .icons" ).append( '<i class="fa fa-user"></i>' );
  jQuery(".header-links .cusstom-link").hide();
  jQuery(".header-links .icons i").addClass("accordion-show");
  jQuery(".header-links .icons i").click(function(){
    if(jQuery(this).parent().next().is(":visible")){
      jQuery(this).addClass("accordion-show");
    }else{
      jQuery(this).removeClass("accordion-show");
    }
    jQuery(this).parent().next().toggle(400);
  });


  jQuery(window).scroll(function() {
    if (jQuery(this).scrollTop() > 200) {
      jQuery("#back-top").fadeIn()
    } else {
      jQuery("#back-top").fadeOut()
    }
  });
  jQuery( "div.button-accrion" ).append( '<p class="more btn harman_btn4">more<i class="ti-plus"></i></p>' );

  jQuery(".footer-top h3.module-title i").addClass("accordion-show");
  jQuery("div.button-accrion").click(function(){

    if(jQuery('.footer-container').hasClass('show-footer')){
      jQuery( "div.button-accrion" ).append( '<p class="more btn harman_btn4">more<i class="ti-plus"></i></p>' );
      jQuery('.footer-container').removeClass('show-footer');
      jQuery( "div.button-accrion p.less" ).remove();
    }else{
      jQuery('.footer-container').addClass('show-footer');
      
      jQuery( "div.button-accrion p.more" ).remove();
      jQuery( "div.button-accrion" ).append( '<p class="less btn harman_btn4">less<i class="ti-minus"></i></p>' );
    }

  });

  $(document).ready(function() {

    $(".gts-caret").click(function(){
      if ($(this).parent().parent().parent().find(".widget-content").is(":hidden")) {
        $(this).parent().parent().parent().find(".widget-content").slideDown(300);
        $(this).find('i').removeClass('ti-angle-right');
        $(this).find('i').addClass('ti-angle-down');      
      } else {
        $(this).parent().parent().parent().find(".widget-content").slideUp(300);
        $(this).find('i').removeClass('ti-angle-down');
        $(this).find('i').addClass('ti-angle-right');
      }
    });
  });


  /*------ Footer Menu ------*/

  $(document).ready(function() {
   
    $(".ft-caret").click(function(){
      if ($(this).parent().parent().parent().find(".content").is(":hidden")) {
        $(this).parent().parent().parent().find(".content").slideDown(300);
        $(this).find('i').removeClass('ti-angle-down');
        $(this).find('i').addClass('ti-angle-right');      
      } else {
        $(this).parent().parent().parent().find(".content").slideUp(300);
        $(this).find('i').removeClass('ti-angle-right');
        $(this).find('i').addClass('ti-angle-down');
      }
    });
  });

   // preload page
   var $body = $('body')
   $body.addClass('apus-body-loading');

   setTimeout(function() {
    $body.removeClass('apus-body-loading');
    $('.apus-page-loading').fadeOut(250);
  }, 1500);

   jQuery('#currencies-top').click(function(){
     if(jQuery(this).hasClass('active')){
      jQuery(this).removeClass('active');
     }else{
      jQuery(this).addClass('active');
     }
   });

/*  $(document).ready(function() {

    $(".novetty_caret").click(function(){
      if ($(this).parent().parent().parent().find(".widget-content").is(":hidden")) {
        $(this).parent().parent().parent().find(".widget-content").slideDown(300);
        $(this).find('i').removeClass('ti-angle-right');
        $(this).find('i').addClass('ti-angle-down');      
      } else {
        $(this).parent().parent().parent().find(".widget-content").slideUp(300);
        $(this).find('i').removeClass('ti-angle-down');
        $(this).find('i').addClass('ti-angle-right');
      }
    });
  });*/


  jQuery(document).ready(function($){
    $('#zoom-full-img').click(function(){
      $('#product-featured-image').trigger('click');
    });


    /* Update main product image when a thumbnail is clicked. */
    /*==========================*/


    /* Initialize zoom on main product image */
    var mainProductImage = jQuery('.featured img');
    if (mainProductImage.size()) {
      if (jQuery(window).width() > 782) {
        var zoomedSrc = $('.featured img').attr('src').replace('_master', '');
        $('.featured img')
        .wrap('<span style="display:inline-block; max-width: 100%;"></span>')
        .css('display', 'block')
        .parent()
        .zoom( { url: zoomedSrc } );
      }
    }
  });
  
}(jQuery)); 


